import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';

// 过滤 antd v4 / rc-table 在 React 18 下产生的第三方废弃警告（升级 antd v5 后可移除）
const _consoleError = console.error.bind(console);
console.error = (...args) => {
  if (typeof args[0] === 'string') {
    if (args[0].includes('findDOMNode is deprecated')) return;
    // antd v4 内部 rc-table 的 defaultProps 警告（args[2] 为组件堆栈，包含 node_modules 路径）
    if (args[0].includes('Support for defaultProps') && typeof args[2] === 'string' && args[2].includes('node_modules')) return;
    // @ant-design/compatible Form 兼容层废弃警告（全量迁移到 antd v4 Form 后可移除）
    if (args[0].includes('[antd-compatible: Form]')) return;
    // antd v4 compatible Form 内部将 compact boolean 传给 DOM 元素的警告
    if (args[0].includes('non-boolean attribute') && args[2] === 'compact') return;
  }
  _consoleError(...args);
};
import moment from 'moment';
import { ConfigProvider } from 'antd';
import { BaseProvider, store } from './store';
import wtmonitor from './wutang-monitor.js';
import { ENV_CONFIG } from './constants';
import { closePerspectiveMode, isPerspectiveMode, removeCookie } from './utils';

import './styles/index.less';
import './styles/tailwind.css';
import './sentry';

import zh from 'antd/lib/locale/zh_CN';
import 'moment/locale/zh-cn';

import Route from './routes';

wtmonitor();

moment.locale('zh-cn');

const RECAPTCHA_SCRIPT = 'laigu_recaptch';

// 全局promise 异常捕获
window.addEventListener('unhandledrejection', function(e) {
  e.preventDefault();
  return true;
});

// 清除旧的cookie
if (document.location.hostname !== 'localhost') {
  const expires = new Date();
  expires.setTime(expires.getTime() - 1);

  document.cookie = `_agent_id=123; expires=${expires.toGMTString()}`;
  document.cookie = `_enterprise_id=123; expires=${expires.toGMTString()}`;
  document.cookie = `_authenticated=123; expires=${expires.toGMTString()}`;
}

const App = () => {
  useEffect(() => {
    if (window.CUSTOM_CONFIG && !window.CUSTOM_CONFIG[window.CUSTOM_NAME].recaptcha) return;
    if (!document.getElementById(RECAPTCHA_SCRIPT)) {
      const recaptchaNode = document.createElement('script');
      recaptchaNode.id = RECAPTCHA_SCRIPT;
      recaptchaNode.src = `https://www.recaptcha.net/recaptcha/api.js?render=${ENV_CONFIG.RECAPTCHA_KEY}`;
      recaptchaNode.defer = true;
      document.body.appendChild(recaptchaNode);
    }
    document.body.style.overflowX = 'hidden';
    return () => {
      const node = document.getElementById(RECAPTCHA_SCRIPT);
      if (node) {
        document.body.removeChild(node);
      }
      document.body.style.overflowX = 'unset';
    };
  }, []);

  useEffect(() => {
    // 用 pagehide 而不是 beforeunload：下载/mailto 等“发起了导航但页面并未卸载”的场景
    // 会触发 beforeunload 却随后取消导航，导致代登录 cookie 被误清（页面留在原地全线 401）
    const pagehide = () => {
      if (isPerspectiveMode()) {
        removeCookie('_enterprise_id');
        removeCookie('_agent_id');
        removeCookie('_authenticated');
        closePerspectiveMode();
      }
    };
    window.addEventListener('pagehide', pagehide);
    return () => {
      window.removeEventListener('pagehide', pagehide);
    };
  }, []);

  return (
    <BaseProvider store={store}>
      <ConfigProvider locale={zh}>
        <Route />
      </ConfigProvider>
    </BaseProvider>
  );
};

createRoot(document.getElementById('main')).render(<App />);
